import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardStandard from "./CardStandard";

const mobile = window.matchMedia("screen and (max-width: 767px)").matches;
const tablet = window.matchMedia("screen and (max-width: 1024px) and (min-width: 768px)").matches;

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
    
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 767, min: 0 },
    items: 1,
  },
};

const ButtonGroup = ({ size, next, previous, goToSlide, ...rest }) => {

  var lenghtSlider = size;
  var { carouselState: { currentSlide } } = rest;
  
  const nextSlide = () => {
      next();
      var btnRight = document.getElementById('btnRight');
      btnRight.disabled = true;
      var spanSlide = document.getElementById('spanSlide');
      var pagination = parseInt(document.getElementById('spanSlide').textContent);
      if (pagination < lenghtSlider && pagination >= 1) {
          spanSlide.textContent = pagination + 1;
          btnRight.disabled = false;
      }
      else {
          spanSlide.textContent = 1
          btnRight.disabled = false;
      }
  }
  const prevSlide = () => {
      previous();
      var btnLeft = document.getElementById('btnLeft');
      btnLeft.disabled = true;
      var spanSlide = document.getElementById('spanSlide');
      var pagination = parseInt(document.getElementById('spanSlide').textContent);
      if (pagination <= lenghtSlider && pagination > 1) {
          spanSlide.textContent = pagination - 1;
          btnLeft.disabled = false;
      }
      else {
          spanSlide.textContent = lenghtSlider
          btnLeft.disabled = false;
      }
  }
  return (
      <div className="carousel-button-group customArrow d-flex align-items-center justify-content-center">
          <button id="btnLeft" className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left" onClick={() => prevSlide()}> </button>
          <span className="spanSlide">
              {
                  <span id="spanSlide">1</span>
              } of {
                  lenghtSlider
              }
          </span>
          <button id="btnRight" className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right" onClick={() => nextSlide()} > </button>
      </div>
  );
};

const CarouselCard = ({ elements }) => {

  return (
    <div className="container-fluid p-xs-0 mt-5">
      <Carousel
        swipeable={mobile || tablet}
        arrows={false}
        ssr={false}
        draggable={false}
        slidesToSlide={1}
        showDots={false}
        responsive={responsive}
        centerMode={!mobile ? true : false}
        infinite={true}
        minimumTouchDrag={5}
        rewindWithAnimation={true}
        autoPlay={false}
        keyBoardControl={false}
        transitionDuration={100}
        customTransition="transform .5s linear"
        containerClass="carousel-card-home carousel-home-custom-pb"
        itemClass="carousel-card-home-item"

        customButtonGroup={<ButtonGroup size={elements?.length} />}>
        {elements?.map((item, index) => (
          <div
            className={`position-relative d-flex`}
            key={index}>
               <div className="opacityCarousel">
               </div>
            <CardStandard card={item} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselCard;